import React, { Fragment } from "react";
import { Col, Container, Row, Button } from "reactstrap";
import { Link } from "react-router-dom";

const GroupTransaksi = () => {
  return (
    <Fragment>
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Row className="text-center">
              <Link
                to={`${process.env.PUBLIC_URL}/transaksi/buatbarugroup`}
                className="p-3"
              >
                <Button className="rounded w-50">
                  <p className="m-5 p-3 fs-3">Buat Baru</p>
                </Button>
              </Link>
              <Link
                to={`${process.env.PUBLIC_URL}/transaksi/susulangroup`}
                className="p-3"
              >
                <Button className="rounded w-50">
                  <p className="m-5 p-3 fs-3">Susulan</p>
                </Button>
              </Link>
            </Row>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
export default GroupTransaksi;
